import React, { useEffect, useState } from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import DOMPurify from "dompurify";
import api from "../../api/axiosClient";

import LoadingComponent from "../../components/common/Loading";
import HTMLParser, { Element } from 'html-react-parser';

/** Single-page section but kept slug-friendly for future expansion */
const SLUGS = { recc: "recc" };

async function fetchCmsByPrefix(prefix, locale = "") {
    const params = { prefix };
    if (locale) params.locale = locale;
    const res = await api.get("/cms", { params });
    return res.data || {};
}

function decodeEntities(str) {
    if (typeof str !== "string") return "";
    const ta = document.createElement("textarea");
    ta.innerHTML = str;
    return ta.value;
}

function normalizeCmsHtml(val) {
    const raw = typeof val === "string" ? val : "";
    const looksEncoded = /&lt;|&gt;|&amp;|&quot;|&#39;|&#x[0-9A-Fa-f]+;/.test(raw);
    const decoded = looksEncoded ? decodeEntities(raw) : raw;
    return DOMPurify.sanitize(decoded, {
        ALLOWED_ATTR: ['href', 'target', 'rel', 'class']
    });
}

function readText(obj, key, fallback = "") {
    const v = obj?.[key];
    if (typeof v === "string") return v;
    if (v && typeof v === "object" && "value" in v) return v.value ?? fallback;
    return fallback;
}

export default function TrainingWebinarsCmsPage() {
    const { slug = "" } = useParams();
    const { pathname } = useLocation();

    const validSlug = SLUGS[slug] ? slug : "recc";
    const cmsKey = SLUGS[validSlug];
    const cmsPrefix = `training.webinars.`;

    // canonical base
    const inCompany = pathname.startsWith("/company/");
    const inMember = pathname.startsWith("/member/");
    const baseRoot = "/company/training/webinars";
    const needRedirect = slug !== validSlug;

    const [loading, setLoading] = useState(true);
    const [cms, setCms] = useState({});
    const [error, setError] = useState("");

    useEffect(() => {
        let alive = true;
        (async () => {
            setLoading(true);
            setError("");
            try {
                const data = await fetchCmsByPrefix(cmsPrefix);
                if (alive) {
                    setCms(data || {});
                }
            } catch (e) {
                if (alive) setError(e?.response?.data?.message || "Failed to load content.");
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, [cmsPrefix]);

    useEffect(() => {
        let t = readText(cms, `${cmsPrefix}body`, "");

        if (!t || !t.length || t.length <= 0)
            return;

        var sections = document.querySelectorAll(".cms-section.collapsible");
        if (sections.length <= 0)
            return;

        for (let jj = 0; jj < sections.length; jj++) {
            let section = sections[jj];

            let button = document.createElement('div');
            button.className = 'minmaxbtn';

            button.addEventListener('click', (e) => {
                //console.log("click", e);
                let parent = e.target.closest('.collapsible');
                if (parent)
                    parent.classList.toggle('closed');
            });

            section.appendChild(button);
        }
    }, [cms])

    //if (needRedirect) return <Navigate to={`${baseRoot}/${validSlug}`} replace />;

    const title = readText(cms, `${cmsPrefix}title`, "Webinars");
    const bodyHtml = (readText(cms, `${cmsPrefix}body`, ""));



    if (loading)
        return (
            <>
                <LoadingComponent></LoadingComponent>
            </>
        )


    return (
        <div className="cms-page recc">
            <div className="cms-header">
                <div className="cms-title">{title}</div>
            </div>

            <div className="cms-body">
                {bodyHtml ?
                    <>
                        {HTMLParser(bodyHtml)}
                    </>
                    :
                    <>
                        <div className="cms-section">
                            <div className="cms-greybox">
                                <h3>No content has been added for this section yet.</h3>
                            </div>
                        </div>
                    </>
                }

            </div>
        </div>
    )
}


// src/pages/member/TrainingModules.jsx
/*
import React from "react";
import IconComponent from "../../components/common/Icons";

const modules = [
    {
        id: "module-1",
        code: "Module 1",
        title: "Introduction Module – The Renewable Energy Consumer Code",
        description:
            "This module is an introduction to the Renewable Energy Consumer Code and the various organisations involved.",
        docHref: "/assets/training/modules/module-1-training-document.pdf",
        testHref: "../take-test?module=1",
        relatedWebinarAnchor: null, // no direct webinar for intro
    },
    {
        id: "module-2-1",
        code: "Module 2.1",
        title: "Advertising and Sales Promotion",
        description:
            "Focuses on how to advertise and promote your business in a way that complies with consumer protection law and the Code.",
        docHref: "/assets/training/modules/module-2-1-training-document.pdf",
        testHref: "../take-test?module=2.1",
        relatedWebinarAnchor: "module-1", // Webinar Module 1
        webinarHref: "https://player.vimeo.com/video/1168516705?badge=&autopause=0&player_id=0&app_id=58479"
    },
    {
        id: "module-2-2",
        code: "Module 2.2",
        title: "Performance, Proposals, Estimates and Quotes",
        description:
            "Covers performance estimates, written proposals, permissions and financial assumptions to help you prepare clear and accurate quotes.",
        docHref: "/assets/training/modules/module-2-2-training-document.pdf",
        testHref: "../take-test?module=2.2",
        relatedWebinarAnchor: "module-2", // Webinar Module 2
        webinarHref: "https://player.vimeo.com/video/1168516705?badge=&autopause=0&player_id=0&app_id=58479"
    },
    {
        id: "module-3",
        code: "Module 3",
        title: "Contracts",
        description:
            "Looks at how to use fair, compliant contracts that protect both you and your customers while meeting the Code requirements.",
        docHref: "/assets/training/modules/module-3-training-document.pdf",
        testHref: "../take-test?module=3",
        relatedWebinarAnchor: "module-3",
        webinarHref: "https://player.vimeo.com/video/1168516705?badge=&autopause=0&player_id=0&app_id=58479"
    },
    {
        id: "module-4",
        code: "Module 4",
        title: "Paying for order and completing the installation",
        description:
            "Explains the rules around deposits, staged payments, and completion, and how to manage payments responsibly.",
        docHref: "/assets/training/modules/module-4-training-document.pdf",
        testHref: "../take-test?module=4",
        relatedWebinarAnchor: "module-4",
        webinarHref: "https://player.vimeo.com/video/1168516705?badge=&autopause=0&player_id=0&app_id=58479"
    },
    {
        id: "module-5",
        code: "Module 5",
        title: "After Sales",
        description:
            "Covers after-sales responsibilities, warranties and handling complaints so you can provide great service and protect your reputation.",
        docHref: "/assets/training/modules/module-5-training-document.pdf",
        testHref: "../take-test?module=5",
        relatedWebinarAnchor: "module-5",
        webinarHref: "https://player.vimeo.com/video/1168516705?badge=&autopause=0&player_id=0&app_id=58479"
    },
];

export default function TrainingWebinars() {
    return (
        <div className="rma-trainingwebinar">

            <div className="rma-content-header">
                <div className="rch-section">
                    <div className="rch-heading-primary">Training Resources – Webinars</div>
                </div>
            </div>

            <div className="rma-content-body">
                <div className="rma-component">

                    <div className="rc-header">
                        <div className="rch-inner">
                            <div className="rch-left">
                                <div className="svg-bg-blue">
                                    <IconComponent name="trainingmodules" width="20" height="20"></IconComponent>
                                </div>
                                <div className="rch-heading">Webinars</div>
                            </div>
                        </div>
                    </div>
                    <br></br>

                    <div className="rc-body">

                        <div className="rct-row-body">
                            {modules.map((module) => {

                                return (
                                    <div key={module.id} className="rct-row rct-trainingmodule">
                                        <div className="code">{module.code}</div>
                                        <div className="title">{module.title}</div>
                                        <div className="description">{module.description}</div>
                                        <div className="buttonlist">
                                            {module.webinarHref &&
                                                <a href={module.webinarHref} target="_blank" rel="noopener noreferrer" className="btn green outline">Watch the webinar</a>
                                            }

                                            {module.docHref &&
                                                <a href={module.docHref} target="_blank" rel="noopener noreferrer" className="btn blue outline">Download slides</a>
                                            }
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
*/